import { Component } from '@angular/core';

@Component({
  selector: 'app-topic-teaser-right-demo',
  templateUrl: './topic-teaser-right-demo.component.html',
})
export class TopicTeaserRightDemoComponent {}
